import { VerbFetch } from '../../VerbFetch';
import { buildQueryString } from '../StringUtils';

// Admin company actions
export const getCompanyMembers = (params) => {
    const { companyId, query, pathsContext } = params;
    const baseUrl = `${pathsContext.adminServerUrl}/companies/${companyId}/members`;
    const url = buildQueryString(query, baseUrl);

    return VerbFetch(url)
        .then((body) => body)
        .catch((err) => {
            console.error(err);
        });
};

// Admin company actions
export const getCompanyMembersCount = (params) => {
    const { companyId, pathsContext } = params;
    const url = `${pathsContext.adminServerUrl}/companies/${companyId}/memberscount`;

    return VerbFetch(url)
        .then((body) => body)
        .catch((err) => {
            console.error(err);
        });
};
